"use client";
import { useAppStore } from "@/store/app";
import Panel from "@/components/common/Panel";
import Nav from "@/components/site/Nav";
import styles from "./MobileMenu.module.css";
import { useEffect } from "react";

export default function MobileMenu() {
	const showMobileMenu = useAppStore(store => store.showMobileMenu);
	const setShowMobileMenu = useAppStore(store => store.setShowMobileMenu);

	const handleClose = () => {
		setShowMobileMenu(false);
	};

	useEffect(() => {
		function handleResize() {
			if(window.innerWidth >= 768) setShowMobileMenu(false);
		}
		window.addEventListener("resize", handleResize);
		return () => window.removeEventListener("resize", handleResize);
	}, []);

	return (
		<Panel
			open={showMobileMenu}
			// modal={true}
			position="center"
			onClose={handleClose}
			className={styles.MobileMenu}
		>
			<Nav
				onClick={handleClose}
				className={styles.MobileMenuNav}
			/>
		</Panel>
	);
}